import { Injectable } from '@angular/core';
import {
  BokkzRapportageClient,
  EnrichAccountantsverklaringRequest, EnrichGrondslagByIdResult, EnrichGrondslagenRequest,
  JaarrapportageEntity,
  ProfitAppropriation,
  ProfitAppropriationValue
} from './api.bokkz.jaarstukken';
import { ErrorMessage } from './rekenclient.api';
import { BokkzJrDataService } from './bokkz-jr-data-service';
import { EnrichClient } from './snelstart.user.api';
import {catchError, Observable, of, Subscriber} from 'rxjs';
import { ToastService } from '@snelstart/ui-toast';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class BokkzJrLogic {

  public jaarrekeningEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = true;
  public errorResponse = {} as ErrorMessage[];
  public aantalValidaties = {} as number;

  constructor(private bokkzClient: BokkzRapportageClient,
              private enrichClient: EnrichClient,
              private router: Router,
              private toastService: ToastService,
              public dataService: BokkzJrDataService
  ) {
    this.dataService.jaarrapportageEntity.subscribe((value) => (this.jaarrekeningEntity = value));
    this.dataService.isRechtspersoon.subscribe(value => this.isRechtspersoon = value);
    this.dataService.errorResponse.subscribe((value) => (this.errorResponse = value));
    this.dataService.aantalValidaties.subscribe((value) => (this.aantalValidaties = value));
  }

  private getFromSessionStorage<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  private getEntity(): JaarrapportageEntity {
    return this.getFromSessionStorage('jrEntity') || {} as JaarrapportageEntity;
  }

  public getCalculation(entity: JaarrapportageEntity) {
    if (entity?.rapportage?.jaarrekeningen?.at(0)) {
      if (entity?.rapportage?.jaarrekeningen?.at(0)?.balans.balanceSheetBeforeAfterAppropriationResults === undefined) {
        entity.rapportage.jaarrekeningen[0].balans.balanceSheetBeforeAfterAppropriationResults = {} as ProfitAppropriation;
        entity.rapportage.jaarrekeningen[0].balans.balanceSheetBeforeAfterAppropriationResults.value = ProfitAppropriationValue.VOOR;
      }
      const isEntityNaturalPerson = !this.isRechtspersoon;
      this.bokkzClient.getCalculation(entity.rapportage?.jaarrekeningen?.at(0), isEntityNaturalPerson).subscribe({
        next: (jaarrekening) => {
          if (jaarrekening) {
            if (entity && entity.rapportage?.jaarrekeningen?.at(0)) {
              entity.rapportage.jaarrekeningen[0] = jaarrekening;
              this.dataService.updateEntity(entity);
            }
          }
        },
        error: (err) => {
          console.log(err);
        }
      });
    }
  }

  public getValidation(jaarRapportage?: JaarrapportageEntity) {
    setTimeout(() => {
      if (jaarRapportage?.rapportage) {
        this.bokkzClient.getValidation(jaarRapportage.rapportage).subscribe({
          next: (response) => {
            if (response.toString().endsWith('true')) {
              this.dataService.updateAantalValidaties(0);
            } else {
              if ('HV000028: Unexpected exception during isValid call.' === response as unknown as string) {
                const error: ErrorMessage[] = [{
                  error: 'server.error',
                  response: 'HV000028: Unexpected exception during isValid call.'
                }];
                this.dataService.updateErrorResponse(error);
                this.dataService.updateAantalValidaties(1);
              } else {
                this.dataService.updateErrorResponse(response as unknown as ErrorMessage[]);
                this.dataService.updateAantalValidaties(this.errorResponse.length);
              }
            }
          },
          error: (err) => {
            this.dataService.updateAantalValidaties(0);
            console.log(err);
          },
          complete: () => console.log('Succes validation jaarrapportage')
        });
      } else if (this.getEntity().rapportage) {
        this.bokkzClient.getValidation(this.getEntity().rapportage!).subscribe({
          next: (response) => {
            if (response.toString().endsWith('true')) {
              this.dataService.updateAantalValidaties(0);
            } else {
              if ('HV000028: Unexpected exception during isValid call.' === response as unknown as string) {
                const error: ErrorMessage[] = [{
                  error: 'server.error',
                  response: 'HV000028: Unexpected exception during isValid call.'
                }];
                this.dataService.updateErrorResponse(error);
                this.dataService.updateAantalValidaties(1);
              } else {
                this.dataService.updateErrorResponse(response as unknown as ErrorMessage[]);
                this.dataService.updateAantalValidaties(this.errorResponse.length);
              }
            }
          },
          error: (err) => {
            this.dataService.updateAantalValidaties(0);
            console.log(err);
          },
          complete: () => console.log('Succes validation jaarrapportage')
        });
      }
    }, 1200);
  }

  public postJaarraportage(clientId: string, entrypointId: string, sendToAuthorities: boolean) {
    this.bokkzClient.postjaarrapportage(clientId, String(this.jaarrekeningEntity.year), sendToAuthorities, entrypointId, this.jaarrekeningEntity).subscribe({
      next: (response) => {
        if (response) {
          this.getCalculation(response);
          this.dataService.updateEntity(response);
        }
      },
      error: (err) => {
        console.log(err);
        this.toastService.showErrorMessage(`"De gegevens zijn niet opgeslagen."`);
      }
    });
  }

  generateAuditorsReport(clientId: string, jrEntity: JaarrapportageEntity, engagement: string, uncertaintyAboutGoingConcern: boolean, nbaAccountant: boolean, subscription: Subscriber<void>) {
    const request = {
      informatieRapportage: jrEntity.rapportage?.informatieRapportage,
      informatieEntiteit: jrEntity.rapportage?.informatieEntiteit,
      engagementType: { value: engagement },
      uncertaintyAboutGoingConcern: uncertaintyAboutGoingConcern,
      nbaAccountant: nbaAccountant
    } as EnrichAccountantsverklaringRequest;
    this.enrichClient.getEnrichedAccountantsverklaring(request).subscribe({
      next: (accountantsverklaring) => {
        jrEntity.accountantsverklaring = accountantsverklaring;
        this.dataService.updateEntity(jrEntity);
        this.bokkzClient.postjaarrapportage(clientId, String(this.jaarrekeningEntity.year), false, '1911', this.jaarrekeningEntity).subscribe({
          next: (response) => {
            if (response) {
              this.dataService.updateEntity(response);
              setTimeout(() => {
                this.router.navigate([`/pm-report/modules/${clientId}/Samenstellingsverklaring`
                ]);
                subscription.next();
                subscription.complete();
              }, 500);
            } else {
              this.executeErrorAuditorsReport('Duurt te lang');
              subscription.next();
              subscription.complete();
            }
          },
          error: (err) => {
            this.executeErrorAuditorsReport(err);
            subscription.next();
            subscription.complete();
            console.log(err);
          }
        });
      },
      error: (error) => {
        this.executeErrorAuditorsReport(error);
        subscription.next();
        subscription.complete();
      }
    });
  }

  private executeErrorAuditorsReport(error: string) {
    this.toastService.showErrorMessage(
      `Het is helaas niet gelukt de verklaring te genereren behorende bij de jaarrapportage. Je kunt wel verder met de verklaring door de gegevens zelf in te vullen. Onze excuses voor het ongemak.`
    );
  }

  enrichPoliciesByIds(ids: string[]): Observable<EnrichGrondslagByIdResult[]> {
    const request = {
      informatieRapportage: this.jaarrekeningEntity.rapportage?.informatieRapportage,
      informatieEntiteit: this.jaarrekeningEntity.rapportage?.informatieEntiteit,
      jaarrekening: this.jaarrekeningEntity.rapportage?.jaarrekeningen?.at(0),
      formattedExplanationPolicyIds: ids
    } as EnrichGrondslagenRequest;

    return this.enrichClient.getEnrichedGrondslagenByIds(request).pipe(
      catchError(error => {
        this.executeErrorPoliciesByIds(error);
        return of([]);
      })
    );
  }

  private executeErrorPoliciesByIds(error: string) {
    this.toastService.showErrorMessage(
      `Het is helaas niet gelukt de standaard grondslag waarde(n) op te halen. Je kunt wel verder door de grondslag(en) eventueel zelf aan te passen of leeg te maken. Onze excuses voor het ongemak.`
    );
  }
}
